import React from 'react';
import { FiInstagram, FiTwitter, FiYoutube, FiFacebook } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Footer() {
  return (
    <footer className="bg-grunge-black border-t-2 border-sun-yellow/50 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <img 
              src="https://media-manager-c.questera.ai/greta-media/fb12f51ee5b6b5b04fc36e6e38322fdbe9f21a5255319993208ee42085da62af087180258d5c6d79d895c821bb9cc720/images/aW1hZ2UvcG5n/c7ddfdef0fa977fada1e1d6f376569c5.png" 
              alt="Meredith Brooks" 
              className="h-8 w-auto object-contain invert brightness-0 mb-4 opacity-90"
            />
            <p className="text-gray-400 text-sm">
              The exclusive home for fans. Access pre-sale tickets, exclusive merch, and behind-the-scenes content.
            </p>
          </div>
          <div>
            <h4 className="text-lg font-bold text-white mb-4 uppercase">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-sun-yellow transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-sun-yellow transition-colors">Terms of Service</a></li>
              <li><a href="#" className="hover:text-sun-yellow transition-colors">Contact Support</a></li>
              <li><a href="#" className="hover:text-sun-yellow transition-colors">FAQ</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-bold text-white mb-4 uppercase">Follow</h4>
            <div className="flex space-x-4">
              {[FiInstagram, FiTwitter, FiYoutube, FiFacebook].map((Icon, idx) => (
                <a key={idx} href="#" className="text-gray-400 hover:text-sun-yellow transition-colors p-2 bg-gray-900 rounded-full">
                  <SafeIcon icon={Icon} className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-sm text-gray-500">
          &copy; {new Date().getFullYear()} Meredith Brooks. All rights reserved. Built with passion.
        </div>
      </div>
    </footer>
  );
}